'use client';

import type { FC, PropsWithChildren } from 'react';
import { useState } from 'react';
import { LoadingArticleContent } from './components/LoadingArticleContent';
import { useData } from './privacyArticle/hooks/useData';
import { useHeatmap } from './privacyArticle/hooks/useHeatmap';
import { TruthProvider } from './privacyArticle/hooks/useTruth';

export const Providers: FC<PropsWithChildren> = ({ children }) => {
  const { canvasRef } = useHeatmap();
  const [theTruthIsRevealed, setTheTruthIsRevealed] = useState(false);

  const { loading, dataBlocks } = useData();

  return (
    <TruthProvider
      value={{
        revealed: theTruthIsRevealed,
        setRevealed: setTheTruthIsRevealed,
        dataBlocks,
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          opacity: theTruthIsRevealed ? 0.25 : 0.001,
          transition: 'opacity 1s',
        }}
      />

      <LoadingArticleContent loading={loading}>
        {children}
      </LoadingArticleContent>
    </TruthProvider>
  );
};
